import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { EngagementList } from "../../../site";
import { EngagementDataResponse } from "../../core";

export class EngagementListPageFactoryImpl implements EngagementListPageFactoryImpl {
    create(engagementData: EngagementDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (engagementData?.success && engagementData.success === true) {
            if (engagementData.response.length > 0) {
                return <EngagementList data={engagementData.response} />
            }
            return <p>Ainda não há dados para exibir neste momento.</p>

        }
        return <NoDataComponent />
    }
}